import { Link } from "react-router-dom";
import useUserRefs from "../../Hooks/UseUsersQuery/UseUserRefs";
import canAccess from "../../services/accessService/accessService";

export default function UserNameText(props: {
    userId?: string
    asLink?: boolean
}) {
    const { 
        userId = 'XXXXXXXXXXXXX', 
        asLink = false 
    } = props;
    const userRefs = useUserRefs()
    let userName = `${userId}`;
    if (userRefs && userId && userRefs[userId]) {
        userName = `${userRefs[userId].firstName} ${userRefs[userId].lastName}`;
    }
    // make sure userId is a validObjectId format before linking
    if (asLink && canAccess('user', 'view') && userId && /^[0-9a-fA-F]{24}$/.test(userId)) {
        return <Link to={`/user/${userId}`}>{userName}</Link>
    }
    return <>{userName}</>
}